<template>
  <v-row>
    <v-col>
      <v-card rounded="xl" flat outlined>
        <v-card-title class="py-6">
          <v-icon size="32" class="mr-4">
            {{ icons.mdiShopping }}
          </v-icon>
          <span class="text-body-1 font-weight-bold"> Sipariş Verilen Ürünler</span>
        </v-card-title>

        <v-data-table :headers="headers" :items="items" :items-per-page="-1" hide-default-footer>
          <template v-slot:item.baslik="{ item }">
            <div class="py-4">

            <div class="text-body-1 white--text">
              {{ item.baslik }}
            </div>
            <div class="text-caption" v-html="item.altBaslik">
              
            </div>
            </div>
          </template>
          <template v-slot:item.quantity="{ item }">
            <div class="text-caption">{{ item.quantity }}</div>
          </template>
          <template v-slot:item.birim="{ item }">
            <div class="text-caption">
              {{ unitText(item.birim) }}
            </div>
          </template>
          <template v-slot:item.satis_fiyati="{ item }">
            <div class="text-caption">{{ item.satis_fiyati | currency }}</div>
          </template>
          <template v-slot:item.ara_toplam="{ item }">
            <div class="text-caption">{{ (item.quantity * item.satis_fiyati) | currency }}</div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { computed, ref } from "@vue/composition-api";

//icons
import { mdiShopping } from "@mdi/js";
// Store
import { useCallCenterStore } from "@/stores/callCenter";
import store from "@/store";

export default {
  setup() {
    const callCenterStore = useCallCenterStore();

    const unitText = (item) => {
      return store.state.tanimlar.birim.find((el) => el.value === item)?.text || "TANIMSIZ";
    };

    const headers = ref([
      {
        text: "Başlık",
        value: "baslik",
        sortable: false,
      },
      {
        text: "Miktar",
        value: "quantity",
        align: "right",
        width: "90px",
        sortable: false,
      },
      {
        text: "Birim",
        value: "birim",
        width: "90px",
        sortable: false,
      },
      {
        text: "Birim Fiyat",
        value: "satis_fiyati",
        width: "150px",
        align: "right",
        sortable: false,
      },
      {
        text: "Ara Toplam",
        value: "ara_toplam",
        width: "150px",
        align: "right",
        sortable: false,
      },
    ]);

    const items = computed(() => {
      return callCenterStore.data.products;
    });

    return {
      callCenterStore,
      items,
      headers,
      unitText,
      icons: {
        mdiShopping,
      },
    };
  },
};
</script>

<style></style>
